export default "<kms-card color=\"info\">\n  <kms-widget-webinars></kms-widget-webinars>\n</kms-card>";